module.exports = __webpack_public_path__ + "static/media/Montserrat-Italic.8777b44e.ttf";